import React from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export class GlobalWarningSystem extends React.Component {
  constructor(props) {
    super(props); // Important: Call super(props)
    this.state = { choices: false, words: this.props.words }; // Access props correctly
    this.warningSystem = this.warningSystem.bind(this); // Bind this for warningSystem
  }

  warningSystem(value) {
    if (value === 'yes') { // Use strict equality (===) and string literals
      toast.success("Action confirmed!", { // Toast on success
        position: "top-right", // Customize position
        autoClose: 3000,        // Auto close after 3 seconds
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      this.props.function(); // Access parent's function via props
    } else {
      toast.error("Action cancelled!", { // Toast on cancellation
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      this.props.root();  // Access parent's root function via props
    }
  }

  render() {
    return (
      <div>
        <button onClick={() => this.warningSystem('yes')}>Yes</button> {/* Pass 'yes' as string */}
        <button onClick={() => this.warningSystem('no')}>No</button>   {/* Pass 'no' as string */}
      </div>
    );
  }
}
